const GROSS_REVENUE = 'Gross Revenue';
const GROSS_REVENUE_KEY = 'select_date_total_gross_revenue';
const MAU = 'MAU';
const MAU_KEY = 'select_date_total_mau';
export const DAU = 'AvgDAU';
export const DAU_KEY = 'select_date_avg_dau';
export const YOY_DAU_KEY = `${DAU_KEY}_yoy`;
export const MOM_DAU_KEY = `${DAU_KEY}_mom`;
const ARPU = 'ARPU';
const ARPU_KEY = 'select_date_total_arpu';
const HC = 'HC';
const HC_KEY = 'select_date_total_hc';
const NET_PROFIT = 'Net Profit';
const NET_PROFIT_KEY = 'select_date_total_net_profit';
const NET_PROFIT_COMPLETION = 'Net Profit Completion';
const NET_PROFIT_COMPLETION_KEY = 'select_date_total_net_profit_completion';
const RELEASE_COST_RATE = 'Release Cost Rate';
const RELEASE_COST_RATE_KEY = 'release_cost_rate';
const STAFF_MONTH_RATE = 'Staff Month Rate';
const STAFF_MONTH_RATE_KEY = 'staff_month_rate';

export const RANGE_PICKER_TYPE = 'month';
export const RANGE_PICKER_TYPES = [RANGE_PICKER_TYPE];

// 接口返回字段前端使用映射表
export const RES_FIELDS_MAP: Record<string, { key: string; yoy?: boolean; mom?: boolean }> = {
  [GROSS_REVENUE]: {
    key: GROSS_REVENUE_KEY,
    yoy: true,
    mom: true,
  },
  [MAU]: {
    key: MAU_KEY,
    yoy: true,
    mom: true,
  },
  [DAU]: {
    key: DAU_KEY,
    yoy: true,
    mom: true,
  },
  [ARPU]: {
    key: ARPU_KEY,
    yoy: true,
    mom: true,
  },
  [HC]: {
    key: HC_KEY,
  },
  [NET_PROFIT]: {
    key: NET_PROFIT_KEY,
  },
  [NET_PROFIT_COMPLETION]: {
    key: NET_PROFIT_COMPLETION_KEY,
  },
  [RELEASE_COST_RATE]: {
    key: RELEASE_COST_RATE_KEY,
  },
  [STAFF_MONTH_RATE]: {
    key: STAFF_MONTH_RATE_KEY,
  },
};

// 排序传参字段映射表
export const SORT_REQ_MAP: Record<string, string> = {
  studio: 'studio_name',
  project: 'game_name',
  [GROSS_REVENUE_KEY]: GROSS_REVENUE,
  [MAU_KEY]: MAU,
  [DAU_KEY]: DAU,
  [ARPU_KEY]: ARPU,
  [NET_PROFIT_KEY]: NET_PROFIT,
  [RELEASE_COST_RATE_KEY]: RELEASE_COST_RATE,
};
